var constants = require('../constants');
var surveyStateHistoryConstants = require('../../surveyStateHistory/constants');
var initialState = require('../../initialState');

var surveys = function(state, action) {
  var newstate = Object.assign({},state);
  switch (action.type) {
	  case constants.REQUEST_SURVEYS:
	  	newstate.isFetching = true;
	  	return newstate;
	  case constants.RECEIVE_SURVEYS:
	  	newstate.isFetching = false;
	  	newstate.data = newstate.data.concat(action.surveys);
	  	return newstate;
      case constants.REQUEST_SURVEYS_ERROR:
        newstate.isFetching = false;
        newstate.error = action.errors;
        return newstate;
      case constants.CLEAR_SURVEYS_ERROR:
        newstate.error = {};
        return newstate;
	  case constants.UPDATE_SEQUENCE_INDEX:
	  	newstate.currentSequenceIndex = action.currentSequenceIndex;
	  	return newstate;
      case constants.UPDATE_SURVEY_PROGRESS:
        newstate.progress = action.progress;
        return newstate;
	  case constants.UPDATE_SURVEY_INDEX:
	  	newstate.currentSurveyIndex = action.currentSurveyIndex;
	  	return newstate;
	  case constants.SET_RESPONSE:
	  	newstate.history = state.history.concat([action.surveyId, action.field, action.responses]);
	  	return newstate;
	  case constants.SEED_SURVEY_LIST:
	  	newstate.index = action.surveyList;
	  	newstate.surveyType = action.surveyType;
	  	return newstate;
	  case constants.UPDATE_SURVEY_LIST:
	  	newstate.index = action.surveyList;
	  	return newstate;
      case surveyStateHistoryConstants.GO_PREVIOUS_SURVEY_STATE:
        return Object.assign({}, state, action.previousSurveyState.surveys);
	  default: return state || initialState.surveys;
  }
}

module.exports = surveys;



// WEBPACK FOOTER //
// ./src/common/modules/survey/reducers/surveys.js